import request from "./request";

// 创建一个包含所有功能函数的对象
const api = {
  // 获取栏目
  getWebClassList(data) {
    return request({
      url: "/WebClass/GetWebClassList",
      method: "post",
      data,
    });
  },
  // 站点信息
  getWebSiteInfo(data) {
    return request({
      url: "WebSite/GetWebSiteDtl",
      method: "post",
      data,
    });
  },

  // 网站文章信息管理
  getWebArticleList(data) {
    return request({
      url: "/WebArticle/GetWebArticleList",
      method: "post",
      data,
    });
  },
  // 根据栏目id获取文章信息列表详情【无权限】
  getWebClassArticleList(data) {
    return request({
      url: "/WebArticle/GetWebClassArticleList",
      method: "post",
      data,
    });
  },
// 详情
  getWebArticleDtl(data) {
    return request({
      url: "/WebArticle/GetWebArticleDtl",
      method: "post",
      data,
    });
  },

   // 获取附件列表【无权限】
  getServiceAttachList(data) {
    return request({
      url: "/WebAttach/GetServiceAttachList",
      method: "post",
      data,
    });
  },

  // 网站广告信息管理
  getWebAdvertiseList(data) {
    return request({
      url: "/WebAdvertise/GetWebAdvertiseList",
      method: "post",
      data,
    });
  },
  // 获取站群信息列表【无权限】
  getWebAdvertiseDtl(data) {
    return request({
      url: "/WebAdvertise/GetWebAdvertiseDtl",
      method: "post",
      data,
    });
  },
  // 获取站群信息列表详情【无权限】
  addWebAdvertise(data) {
    return request({
      url: "/WebAdvertise/AddWebAdvertise",
      method: "post",
      data,
    });
  },
  

   // 获取友情链接基本信息列表【无权限】
  getWebFriendlyLinkList(data) {
    return request({
      url: "/WebFriendlyLink/GetWebFriendlyLinkList",
      method: "post",
      data,
    });
  },
  // 获取友情链接基本信息列表详情【无权限】
  getWebFriendlyLinkDtl(data) {
    return request({
      url: "/WebFriendlyLink/GetWebFriendlyLinkDtl",
      method: "post",
      data,
    });
  },
   // 添加留言
   AddConsult(data) {
    return request({
      url: "/Consult/AddConsult",
      method: "post",
      data,
    });
  },
     // 添加留言
     getWebConsultList(data) {
      return request({
        url: "/Consult/WebConsultList",
        method: "post",
        data,
      });
    },
     // 搜索
     searchContent(data) {
      return request({
        url: "/WebArticle/SearchArticleList",
        method: "post",
        data,
      });
    },
};

// 使用export default导出整合后的对象
export default api;



// WEBPACK FOOTER //
// ./src/api/api.js